import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../form/Form";
import { useFormContext } from "react-hook-form";
import {
  BaseSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./BaseSelect";
import FormRequiredLabel from "../label/FormRequiredLabel";
import FixedScrollArea from "../scroll-area/FixedScrollArea";
import { useTranslation } from "react-i18next";

const FormSelect = ({
  name,
  label,
  placeholder = "defaults.selectPlaceholder",
  required = false,
  options,
  onValueChangeHandler = null,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const onValueChange = (value, field) => {
    field.onChange(value);
    if (onValueChangeHandler) {
      onValueChangeHandler(value);
    }
  };

  return (
    <div>
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {required ? (
              <FormRequiredLabel text={label} />
            ) : (
              <FormLabel>{label}</FormLabel>
            )}
            <BaseSelect
              onValueChange={(value) => onValueChange(value, field)}
              defaultValue={field.value}
              disabled={disabled}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t(placeholder)} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <FixedScrollArea className={options?.length >= 6 ? "h-48" : ""}>
                  {options.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </FixedScrollArea>
              </SelectContent>
            </BaseSelect>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default FormSelect;
